import { OverlayType } from '@/lib/enums/OverlayType.enum';
import { OverlayTypeWithKey } from '@/lib/hooks/useOverlayActions';

export const afterOverlayClose = (cb: () => void) => setTimeout(() => cb(), 250);

export const getOverlayNameWithKey = (type: OverlayType, key: string) => `${type}-${key}` satisfies OverlayTypeWithKey
